import { WarningFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { Header } from "antd/es/layout/layout";
import styled, { css } from "styled-components";

import FlexContainer from "@/components/FlexContainer";

const createEnvironmentWatermark = (text: string, fill: string) => {
    const opacity = "0.12";
    const width = 60;
    const height = 36;
    const centerX = width / 2;
    const centerY = height / 2;

    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
            <text
                x="${centerX}"
                y="${centerY}"
                dominant-baseline="middle"
                text-anchor="middle"
                font-family="Arial, sans-serif"
                font-size="12"
                font-weight="700"
                letter-spacing="0.6"
                fill="${fill}"
                fill-opacity="${opacity}"
                transform="rotate(-12 ${centerX} ${centerY})"
            >
                ${text.toUpperCase()}
            </text>
        </svg>
    `;

    return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
};

export const StyledHeader = styled(Header)<{
    $offline: boolean;
    $environment: string;
}>`
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;

    ${({ $offline }) =>
        $offline &&
        css`
            border-bottom: 2px solid #ff4d4f;
        `}

    ${({ $environment, theme }) =>
        $environment !== "prod" &&
        css`
            &::before {
                content: "";
                position: absolute;
                inset: 0;
                pointer-events: none;
                z-index: 0;
                background-image: ${createEnvironmentWatermark(
                    $environment,
                    theme.primaryTypographyColor,
                )};
                background-repeat: repeat;
                background-size: 60px 36px;
                background-position: center;
            }

            > * {
                position: relative;
                z-index: 1;
            }
        `}
`;

export const StyledTopContent = styled.div`
    width: 100%;
    min-height: 44px;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
`;

export const StyledTypographyNetwork = styled(Typography)`
    color: black;
`;

export const StyledNetworkStatusOnline = styled.div`
    position: absolute;
    width: 100%;
    background-color: #52c41a;
    display: flex;
    justify-content: center;
    height: 20px;
    z-index: 1;
`;

export const StyledNotification = styled(FlexContainer)`
    padding: 8px 16px;
    width: 100%;
    background-color: #52c41a;
    opacity: 0.8;
`;

export const StyledWarningFilled = styled(WarningFilled)`
    color: #f16a1b;
    font-size: 24px !important;
`;

export const StyledRightActionsContainer = styled.div`
    margin-left: auto;
    display: flex;
    gap: 8px;
`;
